import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Quill from "quill";
import "quill/dist/quill.snow.css";

const QuillWrap = styled.div`
  display: grid;
  gap: 1rem;
  width: 100%;
  min-width: 0;
  overflow: visible;

  .ql-toolbar.ql-snow {
    border: none;
    background: ${(p) => p.theme.background};
    box-shadow: ${(p) => p.theme.in};
    border-radius: var(--smallRadius) var(--smallRadius) 0 0;
    padding: var(--normalPads);
  }

  .ql-container.ql-snow {
    border: none;
    background: ${(p) => p.theme.background};
    box-shadow: ${(p) => p.theme.in};
    border-radius: 0 0 var(--smallRadius) var(--smallRadius);
    min-height: 16rem;
    overflow: visible;
  }

  .ql-editor {
    min-height: 14rem;
    color: ${(p) => p.theme.color};
    font-size: var(--normalText);
  }

  .ql-editor.ql-blank::before {
    color: ${(p) => p.theme.color};
    opacity: 0.5;
    font-style: normal;
  }

  .ql-snow .ql-stroke {
    stroke: ${(p) => p.theme.color};
  }

  .ql-snow .ql-fill {
    fill: ${(p) => p.theme.color};
  }

  .ql-snow .ql-picker {
    color: ${(p) => p.theme.color};
  }

  .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options {
    background: ${(p) => p.theme.background};
    border: none;
    box-shadow: ${(p) => p.theme.out};
  }

  .ql-toolbar.ql-snow + .ql-container.ql-snow {
    border-top: none;
  }
`;

const ProspectLeadQuillError = styled.div`
    color: var(--error);
`;

/**
 * Renders the shared prospect lead Quill editor field.
 */
export const Sales_Lead_Quill_Field = (props) => {
    const { t } = useTranslation();
    const editorElementRef = useRef(null);
    const quillRef = useRef(null);

    useEffect(() => {
        if (quillRef.current || !editorElementRef.current) {
            return;
        }

        quillRef.current = new Quill(editorElementRef.current, {
            theme: "snow",
            placeholder: props?.placeholder || t("Comment"),
            modules: {
                toolbar: [
                    ["bold", "italic", "underline"],
                    [{ list: "ordered" }, { list: "bullet" }],
                    ["link"]
                ]
            }
        });

        quillRef.current.on("text-change", () => {
            props?.onChange(quillRef.current.root.innerHTML, quillRef.current.getText());
        });
    }, [props, t]);

    useEffect(() => {
        if (!quillRef.current) {
            return;
        }

        if (!props?.value) {
            quillRef.current.setText("");
            return;
        }

        if (quillRef.current.root.innerHTML !== props?.value) {
            quillRef.current.root.innerHTML = props?.value;
        }
    }, [props?.value]);

    return (
        <QuillWrap>
            <div ref={editorElementRef} />
            {props?.error ? (
                <ProspectLeadQuillError>
                    <h6>{props?.error}</h6>
                </ProspectLeadQuillError>
            ) : null}
        </QuillWrap>
    );
};
